import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { scannerApi, apiMessage, extractData } from 'shared/api/scanner'
import { useAuth } from 'context/AuthContext'
import { PERMISSIONS, hasPermission } from 'shared/util/permissions'
import { PermissionEmpty, EmptyState, Skeleton } from 'shared/components/ui/primitives'

function SalesReport() {
  const { eventId } = useParams()
  const { user } = useAuth()
  const [groups, setGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!hasPermission(user, eventId, PERMISSIONS.EVENT_REPORT)) {
      setLoading(false)
      return
    }
    scannerApi
      .eventReport(eventId)
      .then((res) => setGroups(extractData(res)?.aReport || []))
      .catch((err) => setError(apiMessage(err)))
      .finally(() => setLoading(false))
  }, [eventId, user])

  if (!hasPermission(user, eventId, PERMISSIONS.EVENT_REPORT)) return <PermissionEmpty />
  if (loading) {
    return (
      <div className="space-y-3 p-4">
        <Skeleton className="h-32" />
        <Skeleton className="h-32" />
      </div>
    )
  }

  const maxTickets = Math.max(1, ...groups.flatMap((g) => (g.plans || []).map((p) => p.nTicket || 0)))

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-5">
      <h2 className="mb-4 text-4xl font-bold">Sales report</h2>
      {error && <p className="text-danger">{error}</p>}
      {groups.length === 0
        ? (
        <EmptyState title="No sales yet" message="Plan totals will appear here after bookings." />
          )
        : (
        <div className="space-y-4">
          {groups.map((group) => (
            <div key={group._id} className="card-surface p-4">
              <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted">
                {group._id ? new Date(group._id).toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' }) : 'Date'}
              </p>
              <div className="space-y-3">
                {(group.plans || []).map((plan) => (
                  <div key={plan.sPlan}>
                    <div className="mb-1 flex items-center justify-between gap-2">
                      <span className="font-semibold">{plan.sPlan}</span>
                      <span className="text-theme">{plan.nTicket} · ₹{plan.nPrice}</span>
                    </div>
                    <div className="h-2 overflow-hidden rounded-full bg-line">
                      <div className="h-full bg-theme" style={{ width: `${((plan.nTicket || 0) / maxTickets) * 100}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
          )}
    </div>
  )
}

export default SalesReport
